/* Kins · Rediseño: interacciones livianas, sin librerías.
   Todo respeta prefers-reduced-motion y no carga fotos extra si el usuario ahorra datos. */
(function () {
  'use strict';

  var reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var conexion = navigator.connection || {};
  var ahorraDatos = conexion.saveData === true || /(^|-)2g$/.test(conexion.effectiveType || '');

  // Celular: foto de 900 px de alto. Escritorio: 1400 px.
  var escritorio = window.matchMedia('(min-width: 990px)');
  function cargarImagen(img) {
    if (!img || !img.dataset.src) return;
    img.src = escritorio.matches && img.dataset.srcGrande ? img.dataset.srcGrande : img.dataset.src;
    img.removeAttribute('data-src');
    img.removeAttribute('data-src-grande');
  }

  // ¿La foto de frente del tarro llegó convertida y pesada? (CDN de archivos del tema en iPhone)
  function frentePesada() {
    try {
      var img = document.querySelector('.k-tarro img');
      if (!img) return false;
      var e = performance.getEntriesByName(img.currentSrc || img.src)[0];
      return !!(e && e.encodedBodySize > 120000);
    } catch (err) { return false; }
  }

  function alDescansar(fn) {
    var lanzar = function () {
      if ('requestIdleCallback' in window) window.requestIdleCallback(fn, { timeout: 2500 });
      else window.setTimeout(fn, 600);
    };
    if (document.readyState === 'complete') lanzar();
    else window.addEventListener('load', lanzar, { once: true });
  }

  /* ---------- Aparición al entrar en pantalla ---------- */
  var aparecen = document.querySelectorAll('.k-aparece, [data-k-visible]');
  if ('IntersectionObserver' in window && !reducido) {
    var io = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px' });
    aparecen.forEach(function (el) { io.observe(el); });
  } else {
    aparecen.forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* ---------- Hero: el tarro gira solo y se puede girar con el dedo ---------- */
  document.querySelectorAll('[data-k-giro]').forEach(function (caja) {
    var fotos = Array.prototype.slice.call(caja.querySelectorAll('img'));
    if (fotos.length < 2) return;
    var actual = 0;
    // Orden del giro: ida y vuelta (péndulo) entre ángulos vecinos, sin saltos grandes
    var secuencia = (caja.dataset.kSecuencia || '').split(',').filter(Boolean).map(Number);
    if (!secuencia.length) secuencia = fotos.map(function (_, i) { return i; });
    var paso = 0;
    var listo = false;
    var visible = true;
    var temporizador = null;
    var pausaHasta = 0;
    var intervalo = parseInt(caja.dataset.kIntervalo || '2000', 10);

    function mostrar(i) {
      i = (i + fotos.length) % fotos.length;
      if (i === actual) return;
      fotos[actual].classList.remove('is-activa');
      fotos[i].classList.add('is-activa');
      actual = i;
    }
    function avanzar() {
      if (!listo || !visible || document.hidden || Date.now() < pausaHasta) return;
      paso = (paso + 1) % secuencia.length;
      mostrar(secuencia[paso]);
    }
    function arrancar() {
      if (reducido || temporizador) return;
      temporizador = window.setInterval(avanzar, intervalo);
    }

    // La foto de frente ya está cargada; las demás llegan después de la carga, sin retrasar el texto.
    function precargar() {
      if (listo) return;
      var pendientes = fotos.filter(function (f) { return f.dataset.src; });
      var faltan = pendientes.length;
      if (!faltan) { listo = true; arrancar(); return; }
      pendientes.forEach(function (f) {
        var fin = function () { faltan -= 1; if (faltan === 0) { listo = true; arrancar(); } };
        f.addEventListener('load', fin, { once: true });
        f.addEventListener('error', fin, { once: true });
        cargarImagen(f);
      });
    }
    // Video del tarro (opcional): la foto de frente es la portada y el video se pide después de la carga.
    // Movimiento reducido o ahorro de datos: foto fija. Si el video falla o no arranca, vuelve el giro con fotos.
    var contenedor = caja.parentElement;
    var video = contenedor ? contenedor.querySelector('.k-hero__video') : null;
    var videoActivo = false;
    function sinVideo() {
      if (videoActivo || !video) return;
      video.remove(); video = null;
      contenedor.classList.remove('is-video');
      if (!ahorraDatos && !reducido && !frentePesada()) precargar();
    }
    function iniciarVideo() {
      [['kVideoWebm', 'video/webm'], ['kVideoMp4', 'video/mp4']].forEach(function (par) {
        var url = video.dataset[par[0]];
        if (!url) return;
        var fuente = document.createElement('source'); fuente.src = url; fuente.type = par[1];
        fuente.addEventListener('error', function () {
          fuente.setAttribute('data-fallo', '');
          if (video && !video.querySelector('source:not([data-fallo])')) sinVideo(); // fallaron todas las fuentes
        });
        video.appendChild(fuente);
      });
      var espera = window.setTimeout(sinVideo, 8000);
      video.addEventListener('playing', function () {
        if (videoActivo) return;
        videoActivo = true; window.clearTimeout(espera);
        contenedor.classList.add('is-video');
      });
      video.addEventListener('error', sinVideo);
      video.load();
      var intento = video.play();
      if (intento && intento.catch) intento.catch(sinVideo);
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (e) {
          if (!videoActivo) return;
          if (e[0].isIntersecting) { var r = video.play(); if (r && r.catch) r.catch(function () {}); } else video.pause();
        }).observe(contenedor);
      }
    }
    if (video && (reducido || ahorraDatos)) { video.remove(); video = null; }

    // Protección de peso: si la foto de frente llegó pesada (el CDN de archivos del tema la convierte a PNG
    // en iPhone), los demás ángulos no se descargan solos; solo si la persona gira el tarro con el dedo.
    if (video) alDescansar(iniciarVideo);
    else if (!ahorraDatos && !reducido) alDescansar(function () { if (!frentePesada()) precargar(); });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (e) { visible = e[0].isIntersecting; }).observe(caja);
    }

    // Deslizar el dedo: cada 28 px cambia de ángulo.
    var inicioX = null;
    var base = 0;
    var tiempoBase = 0, reanudar = null;
    caja.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      if (videoActivo) {
        window.clearTimeout(reanudar);
        video.pause(); tiempoBase = video.currentTime; inicioX = e.clientX;
        caja.classList.add('is-arrastrando');
        return;
      }
      precargar();
      inicioX = e.clientX;
      base = paso;
      caja.classList.add('is-arrastrando');
    });
    caja.addEventListener('pointermove', function (e) {
      if (inicioX === null) return;
      if (videoActivo && video.duration) {
        var d = video.duration;
        video.currentTime = (((tiempoBase + (inicioX - e.clientX) / 220 * d / 2) % d) + d) % d;
        return;
      }
      var pasos = Math.round((inicioX - e.clientX) / 28);
      if (pasos !== 0) pausaHasta = Date.now() + 5000;
      paso = ((base + pasos) % secuencia.length + secuencia.length) % secuencia.length;
      mostrar(secuencia[paso]);
    });
    var soltar = function () {
      if (inicioX === null) return;
      inicioX = null;
      caja.classList.remove('is-arrastrando');
      if (videoActivo) reanudar = window.setTimeout(function () { var r = video.play(); if (r && r.catch) r.catch(function () {}); }, 2500);
    };
    caja.addEventListener('pointerup', soltar);
    caja.addEventListener('pointercancel', soltar);
    caja.addEventListener('pointerleave', soltar);
    // Teclado: flechas para girar
    caja.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
        e.preventDefault();
        precargar();
        pausaHasta = Date.now() + 5000;
        paso = (paso + (e.key === 'ArrowRight' ? 1 : -1) + secuencia.length) % secuencia.length;
        mostrar(secuencia[paso]);
      }
    });
  });

  /* ---------- Hero: tarro en 3D girando (video del tema) ----------
     La portada (primer cuadro, WebP) ya está en pantalla. El video se pide después de la carga, para que el texto y el botón
     de compra salgan primero: 9:16 en celular, 1:1 en escritorio. Movimiento reducido o ahorro de datos: solo la imagen fija.
     Si el video falla, queda la portada. Se puede girar con el dedo o con las flechas. */
  document.querySelectorAll('[data-k-tarro-3d]').forEach(function (caja) {
    var video = caja.querySelector('.k-hero__video-3d');
    var pista = caja.querySelector('.k-hero__pista');
    if (!video) return;
    if (reducido || ahorraDatos) {
      video.remove();
      if (pista) pista.remove();
      caja.removeAttribute('tabindex');
      caja.setAttribute('aria-label', 'Tarro de Kins Mind Powder, vista de frente');
      return;
    }
    var activo = false;
    var enPantalla = true;
    function reproducir() { var r = video.play(); if (r && r.catch) r.catch(function () {}); }
    alDescansar(function () {
      video.src = escritorio.matches ? video.dataset.kVideoEscritorio : video.dataset.kVideoCelular;
      video.addEventListener('playing', function () {
        if (activo) return;
        activo = true;
        caja.classList.add('is-video');
      });
      video.addEventListener('error', function () { video.remove(); activo = false; caja.classList.remove('is-video'); });
      video.load();
      if (enPantalla) reproducir();
    });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (e) {
        enPantalla = e[0].isIntersecting;
        if (!activo) return;
        if (enPantalla) reproducir(); else video.pause();
      }).observe(caja);
    }

    // Girar con el dedo: 220 px de arrastre = media vuelta. Al soltar, sigue girando solo.
    var inicioX = null, tiempoBase = 0, reanudar = null;
    function mover(segundos) {
      var d = video.duration;
      if (!d) return;
      video.currentTime = ((segundos % d) + d) % d;
    }
    caja.addEventListener('pointerdown', function (e) {
      if (!activo || (e.pointerType === 'mouse' && e.button !== 0)) return;
      window.clearTimeout(reanudar);
      video.pause();
      tiempoBase = video.currentTime;
      inicioX = e.clientX;
      caja.classList.add('is-arrastrando');
    });
    caja.addEventListener('pointermove', function (e) {
      if (inicioX === null) return;
      mover(tiempoBase + (inicioX - e.clientX) / 220 * video.duration / 2);
    });
    var soltar = function () {
      if (inicioX === null) return;
      inicioX = null;
      caja.classList.remove('is-arrastrando');
      reanudar = window.setTimeout(reproducir, 2500);
    };
    caja.addEventListener('pointerup', soltar);
    caja.addEventListener('pointercancel', soltar);
    caja.addEventListener('pointerleave', soltar);
    caja.addEventListener('keydown', function (e) {
      if (!activo || (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight')) return;
      e.preventDefault();
      window.clearTimeout(reanudar);
      video.pause();
      mover(video.currentTime + (e.key === 'ArrowLeft' ? 1 : -1) * video.duration / 12);
      reanudar = window.setTimeout(reproducir, 2500);
    });
  });

  /* ---------- Botones que bajan a otra sección de la página con scroll suave (sin movimiento si se pidió reducirlo) ---------- */
  document.querySelectorAll('a[data-k-scroll-suave]').forEach(function (enlace) {
    enlace.addEventListener('click', function (e) {
      var destino = document.querySelector(enlace.getAttribute('href'));
      if (!destino) return; // sin la sección, el enlace se comporta normal
      e.preventDefault();
      // Llega al contenido de la sección (no a su relleno), justo debajo del encabezado fijo.
      var contenido = destino.querySelector('.k-ancho > *') || destino;
      var encabezado = document.querySelector('#header');
      var alto = encabezado ? encabezado.getBoundingClientRect().height : 0;
      window.scrollTo({ top: contenido.getBoundingClientRect().top + window.pageYOffset - alto - 24, behavior: reducido ? 'auto' : 'smooth' });
      if (history.replaceState) history.replaceState(null, '', enlace.getAttribute('href'));
    });
  });

  /* ---------- Progreso de una sección según el scroll (0 a 1), solo mientras está en pantalla ---------- */
  function seguirScroll(el, alCambiar, calcular) {
    var activo = false;
    var pendiente = false;
    function medir() {
      pendiente = false;
      var p;
      if (calcular) {
        p = calcular();
      } else {
        // 0 cuando el borde superior entra por el 80 % de la pantalla; 1 cuando el elemento ya subió entero
        var r = el.getBoundingClientRect();
        var alto = window.innerHeight;
        p = (alto * 0.8 - r.top) / (r.height + alto * 0.25);
      }
      alCambiar(Math.max(0, Math.min(1, p)));
    }
    function alMover() {
      if (!pendiente) { pendiente = true; window.requestAnimationFrame(medir); }
    }
    new IntersectionObserver(function (e) {
      if (e[0].isIntersecting && !activo) {
        activo = true;
        window.addEventListener('scroll', alMover, { passive: true });
        window.addEventListener('resize', alMover, { passive: true });
        medir();
      } else if (!e[0].isIntersecting && activo) {
        activo = false;
        window.removeEventListener('scroll', alMover);
        window.removeEventListener('resize', alMover);
      }
    }).observe(el);
  }

  /* ---------- Cómo se vive Kins: la línea se dibuja al bajar ---------- */
  document.querySelectorAll('[data-k-tiempo]').forEach(function (lista) {
    var hitos = lista.querySelectorAll('.k-hito');
    if (reducido) {
      lista.style.setProperty('--k-progreso', 1);
      hitos.forEach(function (h) { h.classList.add('is-alcanzado'); });
      return;
    }
    seguirScroll(lista, function (p) {
      var dibujo = Math.min(1, p * 1.05);
      lista.style.setProperty('--k-progreso', dibujo.toFixed(3));
      hitos.forEach(function (h, n) {
        h.classList.toggle('is-alcanzado', dibujo >= (hitos.length === 1 ? 0 : n / (hitos.length - 1)) - 0.02);
      });
    });
  });

  /* ---------- WhatsApp sin tapar botones ----------
     Si un botón de compra o la barra fija queda en la esquina del botón de WhatsApp, este sube por encima. */
  var evitar = 'form[data-type="add-to-cart-form"] .product-form__submit, .sticky-bar, #sticky-bar-button, .kins-cta-final__boton, .k-boton, .cart-drawer .cart__checkout-button';
  var pendienteWa = false;
  function ajustarWa() {
    pendienteWa = false;
    var alto = window.innerHeight;
    var ancho = window.innerWidth;
    var zonaArriba = alto - 96;
    var zonaIzq = ancho - 88;
    var sube = 0;
    document.querySelectorAll(evitar).forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (!r.width || !r.height) return;
      if (r.bottom > zonaArriba && r.top < alto && r.right > zonaIzq && r.left < ancho) {
        sube = Math.max(sube, alto - r.top + 6);
      }
    });
    sube = Math.min(sube, Math.round(alto * 0.45));
    document.documentElement.style.setProperty('--k-wa-sube', sube + 'px');
  }
  function pedirWa() {
    if (!pendienteWa) { pendienteWa = true; window.requestAnimationFrame(ajustarWa); }
  }
  window.addEventListener('scroll', pedirWa, { passive: true });
  window.addEventListener('resize', pedirWa, { passive: true });
  window.addEventListener('load', pedirWa);
  document.addEventListener('click', function () { window.setTimeout(pedirWa, 350); });
  pedirWa();

  /* ---------- Barra fija de compra en celular y tableta ----------
     Visible solo cuando el botón principal de compra ya salió de pantalla por arriba. */
  var barra = document.querySelector('#MainContent .sticky-bar');
  var botonPrincipal = document.querySelector('form[data-type="add-to-cart-form"][id^="product-form-"] .product-form__submit');
  if (barra && botonPrincipal && 'IntersectionObserver' in window) {
    var pantallaChica = window.matchMedia('(max-width: 1199px)');
    new IntersectionObserver(function (e) {
      var r = e[0].boundingClientRect;
      var mostrar = pantallaChica.matches && !e[0].isIntersecting && r.bottom < 0;
      barra.classList.toggle('k-visible', mostrar);
      barra.setAttribute('aria-hidden', mostrar || !pantallaChica.matches ? 'false' : 'true');
      window.setTimeout(pedirWa, 240);
    }).observe(botonPrincipal);
    barra.addEventListener('transitionend', pedirWa);
  }

  /* ---------- Carrito: cambiar a la presentación siguiente con un solo botón ---------- */
  document.addEventListener('click', function (e) {
    var boton = e.target.closest('[data-k-upsell]');
    if (!boton || boton.disabled) return;
    boton.disabled = true;
    boton.setAttribute('aria-busy', 'true');
    var updates = {};
    updates[boton.dataset.de] = 0;
    updates[boton.dataset.a] = parseInt(boton.dataset.cantidad, 10) + parseInt(boton.dataset.cantidadA || '0', 10);
    var enCajon = boton.dataset.contexto === 'cajon';
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(enCajon ? { updates: updates, sections: 'cart-drawer,cart-icon-bubble' } : { updates: updates })
    })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (estado) {
        var cajon = document.querySelector('cart-drawer');
        if (enCajon && cajon && cajon.renderContents && estado.sections) cajon.renderContents(estado);
        else window.location.reload();
      })
      .catch(function () { boton.disabled = false; boton.removeAttribute('aria-busy'); });
  });

  /* ---------- Video de testimonios ----------
     - El reproductor de YouTube no carga hasta el primer toque.
     - Arranca al primer toque. Si el teléfono no deja arrancar con sonido (iPhone), arranca silenciado,
       con subtítulos, y aparece un botón visible para activar el sonido.
     - Se detiene en el segundo indicado (data-k-fin) y vuelve a la portada: no aparecen las sugerencias de YouTube. */
  document.querySelectorAll('[data-k-video]').forEach(function (caja) {
    var id = caja.dataset.kVideo;
    var fin = parseFloat(caja.dataset.kFin || '0');
    var portada = caja.innerHTML; // portada + botón de play, para volver al terminar
    var iframe = null, sonido = null, estado = -1, vigilancia = null;

    function enviar(func, args) {
      if (iframe && iframe.contentWindow) iframe.contentWindow.postMessage(JSON.stringify({ event: 'command', func: func, args: args || [] }), '*');
    }
    function volverAPortada() {
      window.clearTimeout(vigilancia);
      window.removeEventListener('message', alMensaje);
      iframe = null; estado = -1;
      caja.innerHTML = portada;
      caja.classList.remove('is-reproduciendo');
      var b = caja.querySelector('.k-video__boton');
      if (b) { b.setAttribute('aria-label', 'Ver de nuevo el video de testimonios'); b.addEventListener('click', iniciar); }
    }
    function alMensaje(ev) {
      if (!iframe || ev.source !== iframe.contentWindow) return;
      var datos; try { datos = JSON.parse(ev.data); } catch (e) { return; }
      var info = datos && datos.info;
      if (datos.event === 'onStateChange' && typeof info === 'number') estado = info;
      if (info && typeof info === 'object') {
        if (typeof info.playerState === 'number') estado = info.playerState;
        if (fin && typeof info.currentTime === 'number' && info.currentTime >= fin - 0.35) { enviar('pauseVideo'); volverAPortada(); return; }
      }
      if (estado === 0) volverAPortada(); // terminó: se quita antes de que YouTube muestre sugerencias
    }
    function mostrarBotonSonido() {
      if (sonido) return;
      sonido = document.createElement('button');
      sonido.type = 'button';
      sonido.className = 'k-video__sonido';
      sonido.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 9v6h4l5 4V5L8 9H4z" fill="currentColor"/><path d="M16.5 8.5a5 5 0 010 7M19 6a8.5 8.5 0 010 12" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg><span>Activar sonido</span>';
      sonido.addEventListener('click', function () { enviar('unMute'); enviar('setVolume', [100]); enviar('playVideo'); sonido.remove(); sonido = null; });
      caja.appendChild(sonido);
    }
    function iniciar(e) {
      if (e) e.preventDefault();
      var params = 'autoplay=1&playsinline=1&rel=0&modestbranding=1&iv_load_policy=3&cc_lang_pref=es&enablejsapi=1&origin=' + encodeURIComponent(location.origin) + (fin ? '&end=' + Math.round(fin) : '');
      iframe = document.createElement('iframe');
      iframe.src = 'https://www.youtube-nocookie.com/embed/' + id + '?' + params;
      iframe.title = 'Video de testimonios';
      iframe.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
      iframe.allowFullscreen = true;
      caja.innerHTML = '';
      caja.appendChild(iframe);
      caja.classList.add('is-reproduciendo');
      sonido = null; estado = -1;
      window.addEventListener('message', alMensaje);
      iframe.addEventListener('load', function () {
        // pedir al reproductor que informe su estado y su tiempo
        iframe.contentWindow.postMessage(JSON.stringify({ event: 'listening', id: id, channel: 'widget' }), '*');
        enviar('playVideo');
        vigilancia = window.setTimeout(function () {
          if (estado !== 1) {
            // el navegador no dejó arrancar con sonido: arranca silenciado, con subtítulos
            enviar('mute'); enviar('loadModule', ['captions']); enviar('setOption', ['captions', 'track', { languageCode: 'es' }]); enviar('playVideo');
            mostrarBotonSonido();
          }
        }, 1500);
      });
    }
    var boton = caja.querySelector('.k-video__boton');
    if (boton) boton.addEventListener('click', iniciar);
  });
})();

/* Testimonios: video propio del tema. Se descarga y suena solo cuando el cliente toca play; al terminar vuelve a la portada. */
document.querySelectorAll('[data-k-video-archivo]').forEach(function (caja) {
  var video = caja.querySelector('video');
  var boton = caja.querySelector('.k-video__boton');
  if (!video || !boton) return;
  boton.addEventListener('click', function () {
    caja.classList.add('is-reproduciendo');
    video.controls = true;
    video.play();
  });
  video.addEventListener('ended', function () {
    caja.classList.remove('is-reproduciendo');
    video.controls = false;
    video.load(); /* vuelve a mostrar la portada */
  });
});

/* WhatsApp (app WhatsUp, Shadow DOM abierto): el botón flotante sube lo que diga --kins-wa-sube, que la barra fija
   de compra de la ficha pone en su alto mientras se ve (assets/kins-pdp.js). Las variables CSS atraviesan el Shadow DOM. */
(function () {
  var intentos = 0;
  (function ajustar() {
    var host = document.querySelector('whatsup-whatsapp-button');
    if (host && host.shadowRoot) {
      if (host.shadowRoot.querySelector('style[data-kins]')) return;
      var estilo = document.createElement('style');
      estilo.setAttribute('data-kins', '');
      estilo.textContent = '.whatsup-whatsapp-button { bottom: calc(16px + var(--kins-wa-sube, 0px)) !important; transition: bottom .35s ease; }';
      host.shadowRoot.appendChild(estilo);
      return;
    }
    if (++intentos < 40) setTimeout(ajustar, 250); /* la app carga después que el tema: se espera hasta 10 s */
  })();
})();
